<template>
  <div class="media-layout">
    <div class="media-layout__top">
      <p v-if="!!title">
        {{ title }}
      </p>
    </div>

    <div class="media-layout__main">
      <slot />
    </div>

    <div class="media-layout__bottom">
      <button
        class="attest-button attest-button--outlined media-layout__continue-button"
        :disabled="!canContinue"
        data-test-id="MediaLayout_ContinueButton"
        @click="$emit('continue')"
      >
        <slot name="button" />
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    title: {
      type: String,
      default: undefined,
    },
    canContinue: {
      type: Boolean,
      required: true,
    },
  },
  emits: {
    continue: () => true,
  },
})
</script>

<style lang="postcss">
.media-layout {
  display: grid;
  width: 100%;
  height: 100%;
  padding: 5rem 0;
  background-color: #18283a;
  color: white;
  direction: initial;
  grid-template-areas: 'top' 'main' 'bottom';
  grid-template-rows: 1fr 1fr 1fr;
  justify-items: center;

  &__top {
    grid-area: top;
  }

  &__main {
    width: 100%;
    align-self: center;
    grid-area: main;
  }

  &__bottom {
    align-self: end;
    grid-area: bottom;
  }

  &__continue-button {
    max-width: 18rem;
  }
}
</style>
